import { Font, PDFViewer } from "@react-pdf/renderer";
import { Page, Text, Image, View, Document, StyleSheet } from '@react-pdf/renderer';
import UserContext from "../../../../userContext";
import { useContext } from "react";
import MontserratBold from "../../../../fonts/MontserratBold.ttf"
import MontserratRegular from "../../../../fonts/Montserrat-Regular.ttf"
import arial from "../../../../fonts/arial.ttf"

export default function TestCheckInPDF({ inv }) {
    const context = useContext(UserContext)
    const burl = context.getBurl()
    const document = InventoryOut(burl, inv)
    return (
        <PDFViewer style={{ height: 1000, width: "100%" }}>
            {document}
        </PDFViewer>
    )
}
// Font.register({
//     family: 'monts', fonts: [
//         { src: "https://mypacome.fr/wp-content/uploads/2024/05/MontserratBold.ttf", fontWeight: 700 },
//         { src: "https://mypacome.fr/wp-content/uploads/2024/05/Montserrat-Regular.ttf", fontWeight: 600 },
//     ]
// });
// Font.register({
//     family: 'arial', fonts: [
//         { src: "https://mypacome.fr/wp-content/uploads/2024/05/arial.ttf", fontWeight: 600 },
//     ]
// });
const blue = "#003952"
const gold = "#FABA79"
// Create styles

function InventoryOut(burl, inv) {
    const entry = inv || null
    const today = new Date()
    let monthTemp = today.getMonth() + 1;
    monthTemp < 10 ? monthTemp = '0' + monthTemp : monthTemp = '' + monthTemp;
    let dateDayTemp = today.getDate();
    dateDayTemp < 10 ? dateDayTemp = '0' + dateDayTemp : dateDayTemp = '' + dateDayTemp;
    const dateString = `${dateDayTemp}/${monthTemp}/${today.getFullYear()}`;
    return (
        <Document creator="MYPacôme" producer="MYPacôme" title={dateString + " - État des lieux"}>
            <Page size="A4">
                <View style={styles.pageContainer}>
                    {entry ? (
                        <View style={styles.entree}>
                            <Image style={styles.imageTop} source={"https://i.ibb.co/cykW4z1/favicon-removebg-preview.png"} />
                            <View style={styles.headerDiv}>
                                <Text style={styles.header}>ÉTAT DES LIEUX</Text>
                                <Text style={styles.headerSubtitle}>Date de sortie : {dateString}</Text>
                                <View style={styles.sectionTopSeparator}></View>

                            </View>

                            <PDFHeaderRow name="Mandataire" imageURL={"https://i.ibb.co/cykW4z1/favicon-removebg-preview.png"} value={[
                                { value: entry["out-agency"], name: "Agence" },
                                { value: entry["out-agencyAdress"], name: "Adresse" },
                                { value: entry["out-represented"], name: "Représenté par" }
                            ]}>
                            </PDFHeaderRow>
                            <PDFHeaderRow name="Locataire" imageURL={"https://i.ibb.co/QHbF6PN/Untitled-1.png"} value={[
                                { value: entry["out-locataire"], name: "Nom" },
                                { value: entry["out-property-address"], name: "Adresse du bien" }
                            ]}></PDFHeaderRow>

                            <View style={styles.sectionTopDates}>
                                <View style={styles.sectionTopDatesSingle}>
                                    <Text style={styles.sectionTopDatesSingleTitle}>Date d'entrée : </Text>
                                    <Text style={styles.sectionTopDatesSingleContent}>{entry["out-start"]}</Text>
                                </View>
                                <View style={styles.sectionTopDatesSingle}>
                                    <Text style={styles.sectionTopDatesSingleTitle}>Date de sortie : </Text>
                                    <Text style={styles.sectionTopDatesSingleContent}>{entry["out-end"]}</Text>
                                </View>
                            </View>

                            <KeysTable value={[
                                { value: entry["out-key-entree"], name: "Porte d'entrée" },
                                { value: entry["out-key-portail"], name: "Portail" },
                                { value: entry["out-key-bip"], name: "Bip" },
                                { value: entry["out-key-garage"], name: "Garage" },
                                { value: entry["out-key-autres"], name: "Autre(s)" },
                            ]} headers={[
                                { title: "Clé / Bips" },
                                { title: "Nombre et commentaires" }
                            ]} />

                            <HomeRooms value={[
                                { value: entry["out-grade-entree"], name: "Entrée", comments: entry["out-comments-entree"] },
                                { value: entry["out-grade-salon"], name: "Salon", comments: entry["out-comments-salon"] },
                                { value: entry["out-grade-salle-a-manger"], name: "Salle à manger", comments: entry["out-comments-salle-a-manger"] },
                                { value: entry["out-grade-cuisine-cellier"], name: "Cuisine / Cellier", comments: entry["out-comments-cuisine-cellier"] },
                                { value: entry["out-grade-chambres"], name: "Chambre(s)", comments: entry["out-comments-chambres"] },
                                { value: entry["out-grade-salles-de-bain"], name: "Salle(s) de bain", comments: entry["out-comments-salles-de-bain"] },
                                { value: entry["out-grade-wc"], name: "WC", comments: entry["out-comments-wc"] },
                            ]} />

                            <HomeGeneral value={[
                                { value: entry["out-grade-privatised"], name: "Parties privatisées", comments: entry["out-comments-privatised"], note: "(Balcon, terrasse, parking, garage, jardin, piscine, ...)" },
                                { value: entry["out-grade-equipments"], name: "Autres équipements", comments: entry["out-comments-equipments"], note: "(Sonnette, interphone, boîte aux lettres, portail, cheminée, poêle….)" },
                                { value: entry["out-grade-general"], name: "Observations générales et suggestions", comments: entry["out-comments-general"] }
                            ]} />

                            <Counters value={[
                                { value: entry["out-count-water"], name: "Eau", icon: "https://i.ibb.co/WtyQd2D/drop-1.png" },
                                { value: entry["out-counter-gas"], name: "Gaz", icon: "https://i.ibb.co/cyGjnSq/tuyau.png" }
                            ]} />

                            <Text style={[styles.textareaTitle, styles.counters]}>Les règles de la location</Text>
                            <View style={styles.noteContainer}>
                                <Text style={styles.ruleNote}>Les règles sont également disponibles en Anglais en bas de ce document.</Text>
                                <Text style={styles.ruleNote}>The rules are also available in English at the bottom of this document.</Text>
                            </View>

                            <Rules value={[
                                { title: "Dispositif et électroménager", content: "Si une machine ou un dispositif ne fonctionne pas ou que vous n’êtes pas sûr de savoir l’utiliser, contactez votre concierge. En cas de panne, merci de nous contacter.", icon: "https://i.ibb.co/0YftFnz/home-appliance.png" },
                                { title: "Nettoyage du logement", content: "Toute réclamation doit être effectuée le jour de votre arrivée pour être recevable. Nous mettons à votre disposition en option serviettes de bain, draps.", icon: "https://i.ibb.co/N1fbQhG/cleaning.png" },
                                { title: "Non-fumeur", content: "Le logement est entièrement non-fumeur.", icon: "https://i.ibb.co/9h6mcQC/no-smoking.png" },
                                { title: "Animaux", content: "Autant que nous aimons les chiens et les chats ou tout autre animal, ils ne sont autorisés dans le logement que sous permission directe du propriétaire.", icon: "https://i.ibb.co/gZzj1bj/pet.png" },
                                { title: "Amis et famille", content: "Nous vous demandons de respecter le nombre de personnes maximum autorisé dans le logement ainsi que le nombre de personnes confirmés au moment de la réservation.", icon: "https://i.ibb.co/BtxxCPm/group.png" },
                                { title: "Meubles", content: "Nous vous demandons de ne pas déplacer le mobilier à l’intérieur de l’appartement.", icon: "https://i.ibb.co/41hzRyr/sofa.png" },
                                { title: "Toilettes / WC", content: "Ne rien jeter dans les toilettes autres que du papier toilette, des poubelles sont à votre disposition.", icon: "https://i.ibb.co/SvjLb3n/public-toilet.png" },
                                { title: "Objets et décorations", content: "Tous les objets que vous trouvez dans l’appartement nous appartiennent et ne doivent être ni touchés, ni retirés.", icon: "https://i.ibb.co/V9zybRK/banned.png" },
                                { title: "Horaires calmes", content: "Tout le monde aime bavarder et faire la fête, mais nos voisins sont beaucoup moins d’accord ! Entre 22h00 et 09h00, nous vous demandons de réduire le bruit au maximum.", icon: "https://i.ibb.co/YXp5g1k/sleeping.png" },
                                { title: "Clés", content: "Au moment de votre arrivée, nous vous confions un jeu de clés. Attention à ne pas le perdre. Le cas échéant nous prévoyons des coûts additionnels.", icon: "https://i.ibb.co/HxJHYF2/key-chain.png", bg: 'white' },
                                { title: "Départ", content: "Horaire limite pour votre départ à 10h00 le matin, si vous souhaitez prolonger votre séjour merci de nous contacter.", icon: "https://i.ibb.co/TcD220K/clock.png", bg: 'white' },
                            ]} />

                            <Text style={[styles.textareaTitle, styles.counters]}>Au départ du logement</Text>
                            <Rules value={[
                                { title: "Avant de quitter le logement", content: "Faire votre vaisselle / vider le lave-vaisselle. Merci de sortir les poubelles à l’endroit indiqué par le concierge, le service de ramassage passe tous les matins. Vous vous assurez d’avoir fermé toutes les fenêtres. Assurez-vous de n’avoir rien oublié, y compris chargeurs, téléphones, tablettes etc.... Fermez la porte du logement et donner la clef à votre concierge.", bg: 'white' },
                                { title: "Dommage des lieux", content: "Nous savons que les accidents sont des choses qui arrivent. Après votre départ, nous vérifions le logement pour s’assurer qu’il nous est rendu dans son état initial. En cas de dommage des lieux, les coûts de réparation ou de remise en bon état seront réglés via la carte de crédit déposée en garantie lors de la réservation.", bg: 'white' },
                                { title: "Nettoyage", content: "Il n’est pas nécessaire de nettoyer le logement avant votre départ. Nous vous demandons simplement de le laisser dans un état correct.", bg: 'white' },
                                { title: "Caution", content: "Remise sous 14 jours sous réserve d’après ménage de sortie.", bg: 'white' },
                            ]} border={true} />

                            {
                                entry["out-pool"] === "true" ? (
                                    <>
                                        <Text style={[styles.textareaTitle, styles.counters]}>Piscine</Text>
                                        <Rules pool={true} value={[
                                            {
                                                title: "Décharge piscine",
                                                content: `Il appartient  à nos locataires de prendre toutes les précautions nécessaires pour l'usage de ces installations, en particulier s'ils séjournent avec de jeunes enfants dont ils doivent assurer la surveillance.
                                        Les locataires reconnaissent dégager entièrement la responsabilité du propriétaire en cas d'accident survenant à eux-mêmes, leur famille ou leurs invités. (Afin d'éviter tous risques d'accidents, nous vous demandons de surveiller particulièrement les jeunes enfants).
                                        Les locataires reconnaissent que la sécurité concernant l'accès à la piscine respecte les normes en vigueur, et ce grâce à la présence d'un rideau dont le fonctionnement est expliqué à l’arrivée.
                                        La piscine étant très peu profonde les plongeons et sauts sont dangereux et interdits. 
                                        L’utilisation des bouées et autres matériels est sous la responsabilité des locataires.
                                        Aucune indemnité ne pourra être réclamée par le ou les locataires.
                                        La perte ou la casse des clés de la piscine sera facturée 20€.
                                        Tout arrachage, ou dégradation des sangles piscine seront facturés 30€ par sangle.`,
                                                bg: 'white'
                                            },
                                        ]} border={true} />
                                    </>
                                ) : (<><Text></Text></>)
                            }

                            <Text style={[styles.textareaTitle, styles.counters]}>Signatures</Text>
                            <View style={styles.signaturesContainer}>
                                <View style={styles.signContainer}>
                                    <Text style={styles.textareaTitle}>Le concierge :</Text>
                                    <Image style={styles.signSingle} source={burl + "/" + entry["sortie-sign-concierge"]} />
                                </View>
                                <View style={styles.signContainer}>
                                    <Text style={styles.textareaTitle}>Le locataire :</Text>
                                    <Image style={styles.signSingle} source={burl + "/" + entry["sortie-sign-locataire"]} />
                                </View>
                            </View>
                            {(entry["sortie-sign-consent"] === "false") ? <Text style={[styles.textareaTitle, { fontSize: 14, marginBottom: 20 }]}>Le locataire ne souhaite pas signer l'état des lieux.</Text> : <View></View>}

                            <Text break style={[styles.textareaTitle, styles.counters, { marginTop: 20 }]}>English rules</Text>

                            <Rules value={[
                                { title: "Device and appliances", content: "If a machine or device does not work or you are not sure how to use it, contact your concierge. In case of breakdown, please contact us.", icon: "https://i.ibb.co/0YftFnz/home-appliance.png" },
                                { title: "Cleaning", content: "Any claim must be made on the day of your arrival to be admissible. We provide you with towels, sheets, etc.", icon: "https://i.ibb.co/N1fbQhG/cleaning.png" },
                                { title: "Non-smoking", content: "The accommodation is entirely non-smoking.", icon: "https://i.ibb.co/9h6mcQC/no-smoking.png" },
                                { title: "Pets", content: "As much as we love dogs and cats or any other animal, they are only allowed in the accommodation with direct permission from the owner.", icon: "https://i.ibb.co/gZzj1bj/pet.png" },
                                { title: "Friends and family", content: "We ask you to respect the maximum number of people allowed in the accommodation as well as the number of people confirmed at the time of booking.", icon: "https://i.ibb.co/BtxxCPm/group.png" },
                                { title: "Furniture", content: "We ask you not to move the furniture inside the apartment.", icon: "https://i.ibb.co/41hzRyr/sofa.png" },
                                { title: "Toilets / WC", content: "Do not throw anything in the toilets other than toilet paper, bins are at your disposal.", icon: "https://i.ibb.co/SvjLb3n/public-toilet.png" },
                                { title: "Objects and decorations", content: "All the objects you find in the apartment belong to us and should not be touched or removed.", icon: "https://i.ibb.co/V9zybRK/banned.png" },
                                { title: "Quiet hours", content: "Everyone likes to chat and party, but our neighbors are much less agreeable! Between 10:00 p.m. and 9:00 a.m., we ask you to reduce noise to a minimum.", icon: "https://i.ibb.co/YXp5g1k/sleeping.png" },
                                { title: "Keys", content: "At the time of your arrival, we entrust you with a set of keys. Be careful not to lose it. Otherwise, we provide for additional costs.", icon: "https://i.ibb.co/HxJHYF2/key-chain.png", bg: 'white' },
                                { title: "Departure", content: "The departure time is 10:00 a.m. If you wish to extend your stay, please contact us.", icon: "https://i.ibb.co/TcD220K/clock.png", bg: 'white' },
                            ]} />
                            <Text style={[styles.textareaTitle, styles.counters]}>At the departure of the accommodation</Text>
                            <Rules value={[
                                { title: "Before leaving the accommodation", content: "Do your dishes / empty the dishwasher. Please take out the trash to the place indicated by the concierge, the collection service passes every morning. Make sure you have closed all the windows. Make sure you have not forgotten anything, including chargers, phones, tablets etc.... Close the door of the accommodation and give the key to your concierge.", bg: 'white' },
                                { title: "Damage to the premises", content: "We know that accidents happen. After your departure, we check the accommodation to ensure that it is returned to us in its original condition. In case of damage to the premises, the costs of repair or restoration will be paid via the credit card deposited as a guarantee when booking.", bg: 'white' },
                                { title: "Cleaning", content: "It is not necessary to clean the accommodation before your departure. We simply ask you to leave it in a correct condition.", bg: 'white' },
                                { title: "Deposit", content: "Refund within 14 days subject to after departure cleaning.", bg: 'white' },
                            ]} border={true} />

                        </View>
                    ) : <View></View>}
                </View>
            </Page>
        </Document>
    )
}
function KeysTable({ value, headers }) {
    return (
        <View style={styles.tableKeys} wrap={false}>
            <View style={styles.headerRowKeys}>
                {headers.map((header, index) => {
                    return (
                        <View key={index} style={[styles.headerCellKeys, index === 0 ? styles.headerCellKeysFirst : ""]}>
                            <Text>{header.title}</Text>
                        </View>
                    )
                })}
            </View>
            {value.map((item, index) => {
                return (
                    <View key={index} style={styles.headerRowKeys}>
                        <View style={[styles.cellKeys, styles.cellKeysSubheader]} wrap={false}>
                            <Text>{item.name}</Text>
                        </View>
                        <View style={styles.cellKeys} wrap={false}>
                            <Text>{item.value}</Text>
                        </View>
                    </View>
                )
            })}
        </View>
    )
}


function HomeRooms({ value }) {
    return (
        <View style={styles.categoryRow}>
            <View style={styles.inputRow}>
                {value.map((item, index) => {
                    return (
                        <HomeRoomSingle key={index} value={item.value} name={item.name} comments={item.comments} note={item.note} />
                    )
                })}
            </View>
        </View>
    )
}

function HomeRoomSingle({ value, name, comments }) {
    let bgColour, noteText
    switch (parseInt(value)) {
        case 0:
            bgColour = '#ffffff'
            break
        case 3:
            bgColour = '#ff9f00'
            noteText = "Moyen"
            break
        case 4:
            bgColour = '#ffff00'
            noteText = "Bien"
            break
        case 5:
            bgColour = '#00ff00'
            noteText = "Très bien"
            break
        default:
            bgColour = '#ffffff'
            break;
    }    return (
        <View style={styles.singleRoom} wrap={false}>
            <Text style={styles.titleRoom}>{name}</Text>
            <Text style={[styles.noteRoom, { backgroundColor: bgColour }]}>{noteText}</Text>
            {comments ? (
                <View>
                    <Text style={[styles.commentRoom]}>{comments}</Text>
                </View>) : <Text style={[styles.commentRoom]}>Aucun commentaire.</Text>}
        </View>
    )
}

function HomeGeneral({ value }) {
    return (
        <>
            {value.map((item, index) => {
                return (
                    <View key={index} wrap={false} style={styles.textarea}>
                        <View style={styles.textareaTitle} wrap={false}>
                            <Text>{item.name} : </Text>
                        </View>
                        <View style={styles.textareaTextarea} wrap={false}>
                            <Text>{item.value}</Text>
                        </View>
                    </View>
                )
            })}
        </>
    )
}

function Counters({ value }) {
    return (
        <View wrap={false} style={[styles.textarea, styles.counterContainer]}>
            <View style={[styles.textareaTitle, styles.counters]} wrap={false}>
                <Text>Compteurs</Text>
            </View>
            {value.map((item, index) => {
                return (
                    <View key={index} style={[styles.counterSingleContainer, styles.textareaCounter]}>
                        <View style={[styles.counterIcon]} wrap={false}>
                            <Image style={styles.counterIconIcon} source={item.icon} />
                            <Text style={styles.counterIconName}>{item.name}</Text>
                        </View>
                        <View style={[styles.textareaTextarea, styles.counterTextareaTextarea]} wrap={false}>
                            <Text>{item.value}</Text>
                        </View>
                    </View>
                )
            })}
        </View>

    )
}

function Rules({ value, border, pool }) {
    return (
        <View style={[styles.rulesContainer, border ? styles.rulesBorder : styles.null]}>
            {value.map((item, index) => {
                return (
                    <View key={index} wrap={false} style={[styles.ruleSingle, (pool ? styles.rulePool : (index % 2 === 0 ? styles.ruleEven : styles.ruleOdd)), item.bg ? styles.ruleSingleEnd : styles.null]}>
                        {item.icon ? <View style={styles.ruleIconContainer}>
                            <Image style={styles.ruleIcon} source={item.icon} />
                        </View> : <View></View>}
                        <View>
                            <Text style={[styles.rulesTitle, item.icon ? styles.null : styles.noIcon]}>{item.title}</Text>
                            <Text style={[styles.rulesContent, item.icon ? styles.null : styles.noIcon]}>{item.content}</Text>
                        </View>
                    </View>
                )
            })}
        </View>
    )
}

function PDFHeaderRow({ name, value, imageURL }) {
    return (
        <View style={styles.categoryHeaderRow}>
            <View style={styles.categoryHeaderTopText}>
                <Image style={styles.topIcon} source={imageURL} />
                <Text>{name}</Text>
            </View>
            <View style={styles.inputRowHeader}>
                {value.map((item, index) => {
                    return <PDFInput key={index} value={item.value} name={item.name} type={"header"} />
                })}
            </View>
        </View>
    )
}

function PDFInput({ value, name, type, comments, note }) {
    if (type && type === "color") {
        let bgColour
        switch (parseInt(value)) {
            case 0:
                bgColour = '#ffffff'
                break
            case 1:
                bgColour = '#ff0000'
                break
            case 2:
                bgColour = '#ff9f00'
                break
            case 3:
                bgColour = '#ffff00'
                break
            case 4:
                bgColour = '#dbff00'
                break
            case 5:
                bgColour = '#00ff00'
                break
            default:
                bgColour = '#ffffff'
                break;
        }
        return (
            <View style={styles.inputColor}>
                <Text style={styles.title}>{name}</Text>
                {note ? <Text style={[styles.note, styles.textCenter]}>{note}</Text> : <View></View>}
                <Text style={[styles.contentColor, styles.textCenter, { backgroundColor: bgColour }]}>{value}</Text>
                {comments ? (
                    <>
                        <Text style={[styles.subTitle, styles.textCenter]}>Commentaires :</Text>
                        <Text style={[styles.comment, styles.textCenter]}>{comments}</Text>
                    </>) : <Text style={[styles.comment, styles.textCenter]}>Aucun commentaire.</Text>}
            </View>

        )
    }
    if (type && type === "header") {
        return (
            <View style={styles.inputHeader}>
                <Text style={styles.inputHeaderTitle}>{name} :</Text>
                <Text style={styles.inputHeaderValue}>{value}</Text>
            </View>
        )
    }
    return (
        <View style={styles.inputElement}>
            <Text style={styles.title}>{name}</Text>
            <Text style={styles.content}>{value}</Text>
        </View>
    )
}

const styles = StyleSheet.create({
    pageContainer: {
        margin: "50px auto",
        width: "80%",
    },
    imageTop: {
        width: "30%",
        position: "absolute",
        top: -65,
        right: -100
    },
    header: {

        fontWeight: "600",
        color: blue,
        textAlign: "left",
        fontSize: 35,
        marginTop: 20,
        marginLeft: 0,
    },
    headerDiv: {
        display: "flex",
        flexDirection: "column",
        justifyContent: "left",
        alignItems: "left",
        width: "100%",
    },
    headerSubtitle: {

        fontWeight: 600,
        color: blue,
        textAlign: "left",
        fontSize: 16,
    },
    sectionTopSeparator: {
        borderBottom: "1px solid " + blue,
        width: "50%",
        marginVertical: 20,
    },
    sectionTopText: {

        fontWeight: "700",
        color: blue,
        textAlign: "center",
        fontSize: 25,
        marginTop: 25,
    },

    // First two sections
    categoryHeaderRow: {
        border: "1px solid " + blue,
        margin: "20 auto",
        padding: "30 0 10",
        borderRadius: 28,
        width: "100%",
    },
    inputHeader: {
        flexDirection: 'row',
        justifyContent: 'left',
        paddingVertical: 15,
    },
    inputHeaderTitle: {

        fontWeight: "600",
        color: blue,
        fontSize: 15,
        textAlign: 'left',
        marginHorizontal: 15,
        width: "30%",
    },
    inputHeaderValue: {

        fontWeight: "600",
        fontSize: 15,
        textAlign: 'left',
        marginHorizontal: 10,
        width: "70%",
    },
    inputRowHeader: {
        flexDirection: 'column',
        justifyContent: 'left',
        paddingVertical: 15,
    },
    categoryHeaderTopText: {

        fontWeight: "700",
        color: blue,
        textAlign: "left",
        fontSize: 20,
        marginHorizontal: 15,
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
    },
    topIcon: {
        width: 25,
        height: 25,
        marginRight: 10,
    },

    // Dates section
    sectionTopDates: {
        marginVertical: 20,
    },
    sectionTopDatesSingle: {
        display: "flex",
        flexDirection: "row",
        justifyContent: "left",
        marginVertical: 10,
    },
    sectionTopDatesSingleTitle: {

        fontWeight: "600",
        color: blue,
        fontSize: 15,
    },
    sectionTopDatesSingleContent: {

        fontWeight: "600",
        color: "white",
        backgroundColor: gold,
        fontSize: 12,
        marginLeft: 20,
        padding: "3 30",
        borderRadius: 50,
    },

    // Keys table
    tableKeys: {
        display: 'table',
        width: 'auto',
        marginVertical: 20,
        borderRadius: 20,
    },
    headerRowKeys: {
        flexDirection: 'row',
        flexWrap: 'wrap',
        marginVertical: 0,
        marginTop: 0,
        borderRadius: 0,
    },
    headerCellKeys: {
        width: '65%',
        textAlign: 'center',
        // padding: 5,
        backgroundColor: gold,
        color: "white",
        fontSize: 15,
        padding: "10 0",
        borderTopRightRadius: 9,
        border: "1px solid " + "black",
        borderLeft: "0px",
    },
    headerCellKeysFirst: {
        width: '35%',
        borderTopLeftRadius: 9,
        borderTopRightRadius: 0,
        border: "1px solid " + "black",
        borderLeft: "1px solid " + "black",
    },
    cellKeys: {
        width: '65%',
        textAlign: 'left',
        padding: "20 10",
        fontSize: 12,
        borderBottom: "1px solid black",
        borderRight: "1px solid black",
    },
    cellKeysSubheader: {
        textAlign: 'center',
        width: '35%',
        borderLeft: "1px solid black",
        color: blue,
        fontWeight: "700",
    },

    // Rooms section

    singleRoom: {
        width: "100%",
        marginVertical: 10,
        backgroundColor: "#FDDBBB",
        display: "flex",
        flexDirection: "row",
        flexWrap: "wrap",
        borderRadius: 10,
        overflow: 'hidden',
    },
    titleRoom: {

        fontWeight: "600",
        color: blue,
        textAlign: "left",
        fontSize: 18,
        padding: "15 20",
        width: "70%",
        borderRight: "1.5px solid " + blue,
        borderBottom: "1.5px solid " + blue,
    },
    noteRoom: {

        fontWeight: "600",
        color: blue,
        textAlign: "center",
        fontSize: 16,
        padding: "15 20",
        width: "30%",
        borderBottom: "1.5px solid " + blue,
    },
    commentRoom: {

        fontWeight: "600",
        color: "black",
        textAlign: "left",
        fontSize: 14,
        padding: "15 20",
    },

    // Textareas

    textarea: {
        display: "flex",
        flexDirection: "column",
        justifyContent: "left",
        marginVertical: 10,
    },
    textareaTitle: {

        fontWeight: "600",
        color: blue,
        textAlign: "left",
        fontSize: 16,
    },
    textareaTextarea: {

        fontWeight: "600",
        color: "black",
        textAlign: "left",
        fontSize: 15,
        padding: "20 20",
        marginVertical: 15,
        border: "1px solid " + blue,
        borderRadius: 15,
    },

    // Counters
    counters: {
        textAlign: 'center',
        fontSize: 20,
        width: "100%",
    },
    textareaCounter: {
        width: "40%",
        textAlign: 'center',
        fontSize: 20,
        margin: "0",
        padding: "0",
    },
    counterContainer: {
        display: "flex",
        flexDirection: "row",
        justifyContent: "space-between",
        alignItems: "center",
        padding: "20 0",
        flexWrap: "wrap",
    },
    counterSingleContainer: {
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        width: "100%",
    },
    counterIconIcon: {
        width: 20,
        height: 20,
    },
    counterIcon: {
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        width: "100%",
    },
    counterIconName: {

        fontWeight: "600",
        color: blue,
        textAlign: "center",
        fontSize: 15,
    },
    counterTextareaTextarea: {
        padding: "30 40"
    },

    // Rules

    noteContainer: {
        backgroundColor: blue,
        padding: "20 20",
        borderRadius: 10,
        marginVertical: 20,
        color: "white",
    },
    ruleNote: {

        fontWeight: "600",
        color: "white",
        fontSize: 14,
        marginVertical: 0,
    },
    rulesContainer: {
        display: "flex",
        flexDirection: "column",
        marginVertical: 10,
        padding: "10 0",
    },
    ruleSingle: {
        display: "flex",
        flexDirection: "row",
        alignItems: "center",
        marginVertical: 10,
        padding: "10 0",
        backgroundColor: "#FDDBBB",
        width: "80%",
        fontWeight: "600",
        fontSize: 15,
        borderRadius: 10,
        color: blue,
        justifyContent: "flex-start",
    },
    rulePool: {
        display: "flex",
        flexDirection: "row",
        alignItems: "center",
        marginVertical: 10,
        padding: "10 0",
        backgroundColor: "#FDDBBB",
        width: "100%",
        fontWeight: "600",
        fontSize: 15,
        borderRadius: 10,
        color: blue,
        justifyContent: "flex-start",
    },
    ruleEven: {
        alignSelf: "flex-start",
    },
    ruleOdd: {
        alignSelf: "flex-end",
    },
    rulePool: {
        alignSelf: 'flex-end',
        width: "100%!important",
    },
    ruleSingleEnd: {
        backgroundColor: "white",
        border: "2px solid " + blue,
    },
    ruleIconContainer: {
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        backgroundColor: "white",
        borderRadius: 50,
        padding: 5,
        marginHorizontal: 10,
        border: "4px solid " + blue,
        aspectRatio: 1,
        width: 50,
    },
    rulesTitle: {
        fontWeight: "800",
    },
    ruleIcon: {
        aspectRatio: 1,
        width: 50,
    },
    rulesContent: {
        fontSize: 12,
        width: "80%",
    },
    noIcon: {
        width: "100%",
        paddingHorizontal: 15,
    },

    // Signatures
    signaturesContainer: {
        display: "flex",
        flexDirection: "row",
        justifyContent: "space-between",
        alignItems: "center",
        marginTop: 20,
    },
    signContainer: {
        display: "flex",
        flexDirection: "row",
        justifyContent: "center",
        alignItems: "center",
        width: "50%",
    },
    signSingle: {
        backgroundColor: gold,
        padding: "5",
        borderRadius: 10,
        width: "100",
        height: 50,
        objectFit: "contain",
        marginHorizontal: 20,
        padding: 10,
        margin: "10 auto",
    }

});